/**
 * Shared dimensions for full-width route heroes (inner pages + /contact),
 * aligned with Top Hawk Builders.
 */
export const ROUTE_HERO_BANNER_DESKTOP_MEDIA_QUERY =
   '(min-width: 74.875em)'

export const ROUTE_HERO_BANNER_ASPECT_RATIO = '16 / 9'

export const ROUTE_HERO_BANNER_MAX_HEIGHT_PX = {
   desktop: 610,
   mobile: 400
} as const

export const ROUTE_HERO_BANNER_MIN_HEIGHT_MOBILE_PX = 380

export const ROUTE_HERO_BANNER_OVERLAY_EDGE_PADDING_BOTTOM_PX = {
   desktop: 40,
   mobile: 28
} as const

export const ROUTE_HERO_BANNER_OVERLAY_PADDING_TOP_EXTRA_PX = 16

export const ROUTE_HERO_BANNER_HEADLINE = {
   color: '#e8f0fbd9',
   fontSizePx: {desktop: 55, mobile: 36},
   fontWeight: 650,
   lineHeight: 1.1,
   maxWidthPx: 720
} as const
